export const initializing = '@states/INITIALIZING';
export const idle = '@states/IDLE';
export const loading = '@states/LOADING';
export const error = '@states/ERROR';
export const displayingProviders = '@states/DISPLAYING_PROVIDERS';
